import { createSlice } from '@reduxjs/toolkit';

interface AdminMenuState {
    adminChildSelected: boolean;
    adminOpen: boolean;
}

type StateWithAdminMenu = { adminMenu: AdminMenuState };

const initialState: AdminMenuState = {
    adminChildSelected: false,
    adminOpen: false,
};

const adminMenuSlice = createSlice({
    name: 'adminMenu',
    initialState,

    reducers: (create) => ({
        selected: create.reducer((state) => {
            state.adminChildSelected = true;
        }),

        deselected: create.reducer((state) => {
            state.adminChildSelected = false;
        }),

        menuToggle: create.reducer((state) => {
            if (state.adminChildSelected) {
                state.adminOpen = true;
            }
            else {
                state.adminOpen = !state.adminOpen;
            }
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default adminMenuSlice.reducer;
export const { selected, deselected, menuToggle } = adminMenuSlice.actions;
export const selectAdminOpen = (state: StateWithAdminMenu) => state.adminMenu.adminOpen;
